import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpCommonActions } from "../../actions/mp-common.actions";
import { DistributionKeyState } from "../../models/mp-common/distribution-key-state";

const initialState: DistributionKeyState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpCommonActions.distributionKey.getApi, (state) => ({ ...state, loading: true })),
	on(MpCommonActions.distributionKey.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(MpCommonActions.distributionKey.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function distributionKeyReducer(
	state: DistributionKeyState | undefined,
	action: Action
): DistributionKeyState {
	return reducer(state, action);
}
